import styled from "styled-components";
export const PrimaryContactContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
`;

export const PrimaryContactNote = styled.div`
  background: rgba(255, 237, 209, 1);
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
